"use strict";

var _regeneratorRuntime = require("/root/website/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/root/website/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _defineProperty = require("/root/website/node_modules/@babel/runtime/helpers/defineProperty");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.productByProductType = exports.simulitasService = void 0;

var _constants = require("../../constants");

var _Simulation = require("../../entities/Simulation");

var _fetcher = require("./fetcher");

var _SimulitasException = require("./SimulitasException");

var handleError = function handleError(axiosError) {
  if (!axiosError.response || axiosError.response.status === 500) throw new _SimulitasException.SimulitasException(axiosError.message, _SimulitasException.SimulitasExceptionTypes.SERVER_ERROR);
  if (!axiosError.response.data || !axiosError.response.data.code) throw new _SimulitasException.SimulitasException(axiosError.message, _SimulitasException.SimulitasExceptionTypes.UNKNOWN_ERROR);
  var _axiosError$response$ = axiosError.response.data,
      message = _axiosError$response$.message,
      code = _axiosError$response$.code;
  throw new _SimulitasException.SimulitasException(message, code);
};

var productByProductType = function productByProductType(productType) {
  var _constants$ProductTyp;

  return (_constants$ProductTyp = {}, _defineProperty(_constants$ProductTyp, _constants.ProductTypes.AUTO, 'AUTOREFIN'), _defineProperty(_constants$ProductTyp, _constants.ProductTypes.HOME, 'HOMEREFIN'), _constants$ProductTyp)[productType];
};

exports.productByProductType = productByProductType;

var convertToSimulationList = function convertToSimulationList(items) {
  return items.map(function (item) {
    return new _Simulation.Simulation({
      interestRateMonthly: item.interestRate.monthly,
      installmentsQuantity: item.installments.quantity,
      installmentsAmount: item.installments.amount
    });
  });
};

var simulitasService = function simulitasService() {
  var fetcher = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _fetcher.simulitasFetcher;

  var getSimulations = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _ref2,
          productType,
          intendedCredit,
          _ref2$interestRateTyp,
          interestRateType,
          response,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _ref2 = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, productType = _ref2.productType, intendedCredit = _ref2.intendedCredit, _ref2$interestRateTyp = _ref2.interestRateType, interestRateType = _ref2$interestRateTyp === void 0 ? _constants.InterestRateTypes.MINIMUM : _ref2$interestRateTyp;
              _context.prev = 1;
              _context.next = 4;
              return fetcher.get('/simulations', {
                params: {
                  product: productByProductType(productType),
                  intendedCredit: intendedCredit,
                  interestRateType: interestRateType
                }
              });

            case 4:
              response = _context.sent;
              return _context.abrupt("return", convertToSimulationList(response.data.items));

            case 8:
              _context.prev = 8;
              _context.t0 = _context["catch"](1);
              return _context.abrupt("return", handleError(_context.t0));

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 8]]);
    }));

    return function getSimulations() {
      return _ref.apply(this, arguments);
    };
  }();

  return {
    getSimulations: getSimulations
  };
};

exports.simulitasService = simulitasService;